export default __webpack_public_path__ + "static/media/Ocampos.434921b2.jpg";